<template>
  <span class="fire-label">
    <SvgIcon icon="fire" />
    <span v-text="uppercaseText" />
  </span>
</template>

<script>
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

  export default {
    name: 'FireLabel',
    components: { SvgIcon },
    props: {
      text: {
        type: String,
        required: true,
      },
    },
    computed: {
      uppercaseText() {
        return this.text.toUpperCase();
      }
    }
  };
</script>
